/* eslint-disable */
import { CommunityList } from '../../domain/Community';
import { CommunityRepository } from '../../domain/CommunityRepository';

export async function getAllCommunities(
  communityRepository: CommunityRepository
): Promise<CommunityList[]> {
  return await communityRepository.getAll();
}
